var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4978 64.7543C50.1535 64.7543 64.4662 50.4416 64.4662 32.7859C64.4662 15.1302 50.1535 0.817383 32.4978 0.817383C14.8421 0.817383 0.529297 15.1302 0.529297 32.7859C0.529297 50.4416 14.8421 64.7543 32.4978 64.7543ZM48.4424 25.6449C49.7952 23.9012 49.4784 21.3909 47.7347 20.0381C45.991 18.6852 43.4808 19.0021 42.1279 20.7457L25.4427 42.2512L19.6708 34.8119C18.3179 33.0682 15.8076 32.7514 14.064 34.1042C12.3203 35.4571 12.0034 37.9673 13.3563 39.711L22.2854 51.2197C23.0424 52.1953 24.2078 52.7661 25.4427 52.7661C26.6775 52.7661 27.8429 52.1953 28.5999 51.2197L48.4424 25.6449Z",
    fill: "#00DF80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalSuccessIcon);
export default __webpack_public_path__ + "static/media/modalSuccessIcon.8616303ac27ff641b43659e34b9c2b1a.svg";
export { ForwardRef as ReactComponent };